import React from "react";
import './socialLinks.css';
import '../../../node_modules/font-awesome/css/font-awesome.min.css'; 

export default () => {
    return(
        <span className="social_Links_Container">
            <a target="_blank"  href="https://twitter.com/livshitz98" className="social_icon_button" style={{backgroundColor:"#55acee"}}><i className="fa fa-twitter"></i></a>
            <a target="_blank"  href="https://www.facebook.com/livshutz" className="social_icon_button" style={{backgroundColor:"#3b5998"}}><i className="fa fa-facebook"></i></a>
            <a target="_blank"  href="https://www.linkedin.com/in/livshutz/" className="social_icon_button" style={{backgroundColor:"#007bb5"}}><i className="fa fa-linkedin"></i></a>
            <a target="_blank"  href="https://plus.google.com/110169655249078337437" className="social_icon_button" style={{backgroundColor:"#dd4b39"}}><i className="fa fa-google"></i></a>
        </span>
    )
};


// WEBPACK FOOTER //
// ./src/components/socialLinks/socialLinks.js